












































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import DraggableTreeView from '@/views/structure/DraggableTreeView.vue';
import AmetrasInfoTooltipTemplate from '@/views/AmetrasInfoTooltipTemplate.vue';
import FormTemplate from '@/views/formular/FormTemplate.vue';
import {cloneDeep, set} from 'lodash';
import '@/compiled-icons/arrow-down';
import '@/compiled-icons/arrow-up';
import '@/compiled-icons/delete';
import '@/compiled-icons/table-insert-after';
import '@/compiled-icons/table-insert-before';
import '@/compiled-icons/pencil-outline';
import '@/compiled-icons/add';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {BehaviorSubject, Subscription} from 'rxjs';
import AdvancedConfirmDialog, {ConfirmationDialogConfig} from '@/views/AdvancedConfirmDialog.vue';

interface DialogType extends DisguiseDto.StructureFormularActionDto {
  create: boolean;
  overwrittenFields?: { [fieldName: string]: DisguiseDto.FTFieldDto };
}

interface StructurePositionEnumWithLabel {
  value: DisguiseDto.StructurePositionEnum;
  label: string;
}

interface PositionDialogType {
  title: string;
  value: StructurePositionEnumWithLabel;
  possibleValues: StructurePositionEnumWithLabel[];
  relativeToStructureNode: DisguiseDto.StructureDto<any>;
  cb: (positionDialog: PositionDialogType) => void;
}


@Component({
  components: {AdvancedConfirmDialog, FormTemplate, AmetrasInfoTooltipTemplate, DraggableTreeView}
})

export default class StructureTemplate extends Vue {
  @Prop({
    required: true
  }) templateUrl!: string;
  @Prop() entityUrl!: string;
  @Prop({
    default: null
  }) userRequestedReload!: BehaviorSubject<string> | null; // whenever a user requests a reload, e.g. by submenu tab
  @Prop({
    default: true
  }) reloadOnUserRequest!: boolean; // configuration whether the reload (e.g. by submenu click) will always refresh the content
  loading: boolean = false;
  input: DisguiseDto.StructureListDto<DisguiseDto.StructureDto<any>> = {};
  selectedItem: DisguiseDto.StructureDto<any> | null = null;
  showDialog: boolean = false;
  showPositionDialog: boolean = false;
  formularDialog: DialogType | null = null;
  positionDialog: PositionDialogType | null = null;

  // contains a list of structure ids and their corresponding menu open state
  openStructureMenus: { [key: string]: any } = {};

  confirmationDialogConfig: ConfirmationDialogConfig | null = null;

  private userRequestedReloadSubscription: Subscription | undefined;
  private lastUserRequestedReloadReqId: string = '';

  @Watch('userRequestedReload') userRequestedReloadChanged() {
    this.bindToReload();
  }

  created() {
    this.loadData();
  }

  mounted() {
    this.bindToReload();
  }

  destroyed() {
    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
  }

  structureUpdated(
      newStructure: Array<DisguiseDto.StructureDto<any>>
  ): void {
    this.input.structure = newStructure;
  }

  itemSelected(
      selectedItem: DisguiseDto.StructureDto<any>
  ): void {
    this.selectedItem = selectedItem;
  }

  save(
      newStructure: DisguiseDto.StructureListDto<any>
  ): void {
    HTTP_SERVICE_INSTANCE.getAxios().put(this.entityUrl, newStructure);
  }

  closeDialog() {
    this.formularDialog = null;
    this.showDialog = false;
  }

  closePositionDialog() {
    this.positionDialog = null;
    this.showPositionDialog = false;
  }

  getItemActionIcon(icon: DisguiseDto.StructureActionIconEnum) {
    let result = '';

    if (icon === 'DELETE') {
      result = 'delete';
    } else if (icon === 'INSERT_AFTER') {
      result = 'table-insert-after';
    } else if (icon === 'INSERT_BEFORE') {
      result = 'table-insert-before';
    } else if (icon === 'MOVE_DOWN') {
      result = 'arrow-down';
    } else if (icon === 'MOVE_UP') {
      result = 'arrow-up';
    } else if (icon === 'EDIT') {
      result = 'pencil-outline';
    } else if (icon === 'ADD') {
      result = 'add';
    }

    return result;
  }

  afterFormularSaved() {
    this.loadData();
    this.closeDialog();
  }

  itemActionClicked(event: Event,
                    action: DisguiseDto.StructureActionDto,
                    item: DisguiseDto.StructureDto<any>,
                    deleteItem: (item: DisguiseDto.StructureDto<any>) => void,
                    moveUp: (item: DisguiseDto.StructureDto<any>) => void,
                    moveDown: (item: DisguiseDto.StructureDto<any>) => void) {
    event.stopPropagation();
    if (action.confirmationText) {
      this.confirmationDialogConfig = {
        title: 'Bestätigen',
        headerColor: 'primary',
        message: action.confirmationText,
        buttons: [{
          text: 'Bestätigen',
          title: 'Bestätigen',
          disabled: false,
          loading: false,
          autoFocus: true,
          onClick: () => {
            this.executeItemAction(action, item, deleteItem, moveUp, moveDown);
            this.confirmationDialogConfig = null;
          }
        }, {
          text: 'Abbrechen',
          title: 'Abbrechen',
          disabled: false,
          loading: false,
          onClick: () => {
            this.confirmationDialogConfig = null;
          }
        }],
        onEsc: () => {
          this.confirmationDialogConfig = null;
        }
      };
    } else {
      this.executeItemAction(action, item, deleteItem, moveUp, moveDown);
    }
  }

  itemMenuItemActionClicked(event: Event,
                            action: DisguiseDto.StructureMenuActionItemDto,
                            item: DisguiseDto.StructureDto<any>,
                            deleteItem: (item: DisguiseDto.StructureDto<any>) => void,
                            moveUp: (item: DisguiseDto.StructureDto<any>) => void,
                            moveDown: (item: DisguiseDto.StructureDto<any>) => void) {
    if (action.structureAction) {
      this.itemActionClicked(event, action.structureAction, item, deleteItem, moveUp, moveDown);
    }
  }

  executeItemAction(action: DisguiseDto.StructureActionDto,
                    item: DisguiseDto.StructureDto<any>,
                    deleteItem: (item: DisguiseDto.StructureDto<any>) => void,
                    moveUp: (item: DisguiseDto.StructureDto<any>) => void,
                    moveDown: (item: DisguiseDto.StructureDto<any>) => void) {
    if (action.type === 'StructureHttpActionDto') {
      const castedAction = action as DisguiseDto.StructureHttpActionDto;
      if ('GET_NEW_TAB' === castedAction.endpointMethod) {
        window.open(castedAction.actionUrl, '_blank');
        switch (action.action) {
          case 'DELETE':
            deleteItem(item);
            this.loading = false;
            break;
          default:
            this.loadData();
            break;
        }
      } else {
        this.loading = true;
        HTTP_SERVICE_INSTANCE.getAxios().request({
          method: castedAction.endpointMethod,
          url: castedAction.actionUrl,
          data: item
        }).then(() => {
          switch (action.action) {
            case 'DELETE':
              deleteItem(item);
              this.loading = false;
              break;
            default:
              this.loadData();
              break;
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    } else if (action.type === 'StructureFormularActionDto') {
      const castedAction = action as DisguiseDto.StructureFormularActionDto;
      const overwrittenFields: { [fieldName: string]: DisguiseDto.FTFieldDto } = {};
      set(overwrittenFields,
          castedAction.formular?.relativeToIdDtoPath || '',
          {
            value: String(item.id)
          }
      );
      set(overwrittenFields,
          castedAction.formular?.relativeToNameDtoPath || '',
          {
            value: String(item.name)
          }
      );

      switch (action.action) {
        case 'INSERT_AFTER':
          set(overwrittenFields,
              castedAction.formular?.relativeToPositionDtoPath || '',
              {
                value: 'AFTER'
              }
          );
          break;
        case 'INSERT_BEFORE':
          set(overwrittenFields,
              castedAction.formular?.relativeToPositionDtoPath || '',
              {
                value: 'BEFORE'
              }
          );
          break;
        default:
          break;
      }

      this.formularDialog = {
        type: 'StructureFormularActionDto',
        create: castedAction.formular?.create || false,
        dialogTitle: castedAction.dialogTitle,
        formular: castedAction.formular,
        maxWidth: castedAction.maxWidth,
        overwrittenFields
      };
      this.showDialog = true;
    } else if (action.type === 'StructureActionDto') {
      switch (action.action) {
        case 'MOVE_DOWN':
          moveDown(item);
          break;
        case 'MOVE_UP':
          moveUp(item);
          break;
        default:
          break;
      }
    }

  }

  structureActionMenuItemClicked(action: DisguiseDto.StructureMenuActionItemDto) {
    if (action.structureAction) {
      this.structureActionClicked(action.structureAction);
    }
  }

  structureActionClicked(action: DisguiseDto.StructureActionDto) {
    if (action.type === 'StructureFormularActionDto') {
      const dialogAction = action as DisguiseDto.StructureFormularActionDto;

      if (!this.selectedItem) {
        this.formularDialog = {
          type: action.type,
          create: dialogAction.formular?.create || false,
          dialogTitle: dialogAction.dialogTitle,
          formular: dialogAction.formular,
          maxWidth: dialogAction.maxWidth
        };
        this.showDialog = true;
      } else {
        const possibleValues: StructurePositionEnumWithLabel[] = [
          {
            label: 'Vor dem gewählten Navigationspunkt',
            value: 'BEFORE'
          },
          {
            label: 'Nach dem gewählten Navigationspunkt',
            value: 'AFTER'
          }
        ];
        if (!this.selectedItem.isLeaf) {
          possibleValues.push({
            label: 'In dem gewählten Navigationspunkt',
            value: 'INSIDE'
          });
        }

        this.positionDialog = {
          title: 'Einfügeoptionen',
          value: {
            label: 'Vor dem gewählten Navigationspunkt',
            value: 'BEFORE'
          },
          relativeToStructureNode: cloneDeep(this.selectedItem),
          possibleValues,
          cb: (positionDialog: PositionDialogType) => {
            this.closePositionDialog();

            const overwrittenFields: { [fieldName: string]: DisguiseDto.FTFieldDto } = {};
            set(overwrittenFields,
                dialogAction.formular?.relativeToIdDtoPath || '',
                {
                  value: String(positionDialog.relativeToStructureNode.id)
                }
            );
            set(overwrittenFields,
                dialogAction.formular?.relativeToPositionDtoPath || '',
                {
                  value: String(positionDialog.value)
                }
            );
            set(overwrittenFields,
                dialogAction.formular?.relativeToNameDtoPath || '',
                {
                  value: positionDialog.relativeToStructureNode.name
                }
            );

            this.formularDialog = {
              type: 'StructureFormularActionDto',
              create: dialogAction.formular?.create || false,
              dialogTitle: dialogAction.dialogTitle,
              formular: dialogAction.formular,
              maxWidth: dialogAction.maxWidth,
              overwrittenFields
            };
            this.showDialog = true;
          }
        };
        this.showPositionDialog = true;
      }
    }
  }

  private bindToReload() {
    if (this.userRequestedReloadSubscription) {
      this.userRequestedReloadSubscription.unsubscribe();
    }
    if (this.userRequestedReload) {
      this.userRequestedReloadSubscription = this.userRequestedReload.subscribe((reqId) => {
        if (this.input.structure) { // ever loaded data
          if (this.reloadOnUserRequest && this.lastUserRequestedReloadReqId !== reqId) {
            this.lastUserRequestedReloadReqId = reqId;
            this.loadData();
          }
        }
      });
    }
  }

  private loadData() {
    this.loading = true;

    let templateURL = `${this.templateUrl}`;
    if (templateURL.indexOf('?') >= 0) {
      templateURL += `&`;
    } else {
      templateURL += '?';
    }

    HTTP_SERVICE_INSTANCE.getAxios()
        .get<DisguiseDto.StructureListDto<DisguiseDto.StructureDto<any>>>(templateURL)
        .then((response) => {
          this.input = response.data;
          Vue.nextTick().then(() => {
            this.loading = false;
          });
        }, (error) => {
          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
            this.$store.commit('showSnack', {
              message: 'Laden des Datensatzes fehlgeschlagen',
              color: 'error'
            });
          }
          this.loading = false;
        });
  }
}
